import React from 'react';

const MOCK_GENRES = [
  { name: 'Metal', pct: 78 },
  { name: 'Prog', pct: 64 },
  { name: 'Hardcore', pct: 31 },
  { name: 'Indie', pct: 12 },
];

const MOCK_ARTISTS = [
  { name: 'Periphery', pct: 71 },
  { name: 'Animals as Leaders', pct: 58 },
  { name: 'Mastodon', pct: 44 },
  { name: 'Opeth', pct: 39 },
  { name: 'TesseracT', pct: 34 },
];

const PctBars = ({ rows, tone }) => (
  <ul className="mi-affinity-bar-list">
    {rows.map((r) => {
      const pct = Math.max(0, Math.min(100, Number(r.pct) || 0));
      return (
        <li key={r.name} className="mi-affinity-bar-row">
          <span className="mi-affinity-bar-label">{r.name}</span>
          <span className="mi-affinity-bar-track">
            <span
              className={`mi-affinity-bar-fill mi-affinity-bar-fill-${tone}`}
              style={{ width: `${pct}%` }}
            />
          </span>
          <span className="mi-affinity-bar-value">{pct}%</span>
        </li>
      );
    })}
  </ul>
);

const GenreChips = ({ rows }) => (
  <ul className="mi-affinity-chip-list">
    {rows.map((r) => (
      <li key={r.name} className="mi-affinity-chip">{r.name}</li>
    ))}
  </ul>
);

const AffinityCard = ({ data }) => {
  const isReal = data != null;
  const genres = isReal ? (data.genres || []) : MOCK_GENRES;
  const artists = isReal ? (data.similar_artists || []) : MOCK_ARTISTS;

  return (
    <section className="mi-audience-card mi-affinity-card" aria-label="Genre & artist affinity">
      <div className="mi-audience-card-head">
        <div>
          <h3 className="mi-audience-card-title">Genre &amp; artist affinity</h3>
          <p className="mi-audience-card-subtitle">Buyer history — top correlations</p>
        </div>
        {!isReal && <span className="mi-sample-pill">Sample data</span>}
      </div>

      <div className="mi-affinity-section">
        <h4 className="mi-affinity-section-heading">Genres</h4>
        {data?.genres_fallback && genres.length > 0 ? (
          <>
            <GenreChips rows={genres} />
            <p className="mi-affinity-fallback-note">From lineup — no ticket sales yet.</p>
          </>
        ) : genres.length > 0 ? (
          <PctBars rows={genres} tone="purple" />
        ) : (
          <p className="mi-audience-empty">No genres tagged for this event yet.</p>
        )}
      </div>

      <div className="mi-affinity-section">
        <h4 className="mi-affinity-section-heading">Top similar artists</h4>
        {artists.length > 0 ? (
          <PctBars rows={artists} tone="blue" />
        ) : (
          <p className="mi-audience-empty">No similar artists known for this event yet.</p>
        )}
      </div>
    </section>
  );
};

export default AffinityCard;
